import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { PlantingSiteDto } from '../../../models/trofaco/plantingSiteDto';
import { PhotoCollectionDto } from '../../../models/trofaco/photoCollectionDto';
import { FrontendRouteService } from '../frontend-route.service';
import { PhotoDto } from '../../../models/trofaco/photoDto';
import { BaseComponent } from '../../core/components/bases/base-component';
import { AgmMap } from '@agm/core';
import { PlantingSiteAreaDto } from 'src/app/models/trofaco/plantingSiteAreaDto';

@Component({
    selector: 'app-collection-map',
    templateUrl: './collection-map.component.html',
    styleUrls: ['./collection-map.component.css'],
    providers: [FrontendRouteService]
})
export class CollectionMapComponent extends BaseComponent implements OnInit {
    @ViewChild(AgmMap, {static: true}) map: AgmMap;

    pinUrl = '/assets/img/map-icons/photo-pin-s.png';
    focusedPinUrl = '/assets/img/map-icons/photo-pin-focus.png';

    site: PlantingSiteDto;
    collection: PhotoCollectionDto;
    activePhoto: PhotoDto;
    siteArea: PlantingSiteAreaDto;
    //3 is top right, determined by the ControlPosition type, but we can't import it here
    //so we just hardcode the value
    mapControlPosition = 3;
    readonly mapTypeId = 'hybrid';

    constructor(private frontendRoute: FrontendRouteService, private renderer: Renderer2) {
        super();
    }

    ngOnInit() {
        this.frontendRoute.currentSite$.subscribe(s => this.site = s);
        this.frontendRoute.currentCollection$.subscribe(c => this.collection = c);
        this.frontendRoute.currentPhoto$.subscribe(p => this.activePhoto = p);
        this.frontendRoute.currentPlantingSiteArea$.subscribe(c => this.siteArea = c);

        this.renderer.addClass(document.body, 'footer-hidden');
        this.onDestroy$.subscribe(() => {
            this.renderer.removeClass(document.body, 'footer-hidden');
        });

    }

    navigateToPhoto(photo: PhotoDto) {
        this.frontendRoute.showPhoto(photo);
    }
}
